module.exports = __webpack_public_path__ + "static/media/product2.77917eb4.jpg";